import { render, staticRenderFns } from "./copyBottun.vue?vue&type=template&id=0cac95cf&scoped=true"
import script from "./copyBottun.vue?vue&type=script&lang=js"
export * from "./copyBottun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cac95cf",
  null
  
)

export default component.exports